import script from "./MediaControlBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaControlBar.vue?vue&type=script&setup=true&lang=ts"

import "./MediaControlBar.vue?vue&type=style&index=0&id=6354c62c&lang=scss"

const __exports__ = script;

export default __exports__